import { api } from "..";
import { QueryProps } from "@/types/Api";
import { ChatsPaginatedResponse, GetChatsPaginatedParams } from "./types";

export const getChatsPaginated = async (
  props: QueryProps<GetChatsPaginatedParams>
): Promise<ChatsPaginatedResponse> => {
  const res = await api.client.get("/chats/paginated", {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
